import infoIcon from 'legacy/assets/svg-inline/info.svg';

import IconButton from 'legacy/components/generic/IconButton';

const GlossaryButton = (props) => {
  const { onClick, dataHcName, className } = props;
  return (
    <IconButton
      {...props}
      onClick={onClick}
      icon={infoIcon}
      dataHcName={dataHcName}
      className={className}
    />
  );
};

export default GlossaryButton;
